import { useEffect, useState } from "react";
import { YSButton } from "../../../uikit/YSButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SaveIcon from "../../../images/icons/SaveIcon.svg";
import PrintIcon from "../../../images/icons/PrintIcon.svg";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SendPharmacyIcon from "../../../images/icons/SendPharmacyIcon.svg";
import LockIcon from "@mui/icons-material/Lock";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import {
  AlertInfo,
  BtnGroupStyle,
  DRxSelectStyle,
  HtmlTooltip,
  SummaryBox,
  SummaryBoxScroll,
  SummaryBtns,
  SummaryInfo,
  DRxInputStyle,
  InputSMBoxStyle,
} from "../../../Theme";
import ShowIcon from "@mui/icons-material/Add";
import HideIcon from "@mui/icons-material/Remove";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import {
  RxPrint,
  SAVE,
  saveToMedHistory,
  SubmitPresctiptions,
  summarySendToPharmacyAPI,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import EPCSAlert from "../../../components/EPCSAlert";
import AdverseEffectPOPUp from "../../../components/AdverseEffectPOPUp";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import {
  updateEmailReminder,
  updatePatientEmail,
  updatePatientDemographics,
  updatePatientAddress,
} from "../../../Apis/AuthApiServices";
import * as yup from "yup";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import DrugAllergyInteractions from "../../../components/DrugAllergyInteractions";
import DrugToFoodInteractionPopUp from "../../../components/DrugToFoodInteractionPopUp";
import { loadingPatientDetails } from "../../../Redux/Slice/PatientDetailsSlice";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { loadingPrescriberDetails } from "../../../Redux/Slice/PrescriberDetailsSlice";
import {
  IDME_URL_DOMAIN,
  IDME_URL_END,
  REPORT_BASE_URL,
} from "../../../Apis/Constants";
import { useOnBehalfContext } from "../../../context/OnbehalfContext";
import Backdrop from "@mui/material/Backdrop";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { clearIdmePreferenceState } from "../../../Redux/Slice/IdmeSlice";
import IDME from "../../../components/IDME";
import { saveAsPreferenceApi } from "../../../Apis/Idme2FA";
import { clearClientAuthSession } from "../../../utils/authCookie";
import AIIcon from "../../../images/icons/AIIcon";
import AIMedInfo from "../../../components/AIMedInfo";
import { Link } from "@mui/material";
import Beta1 from "../../../images/icons/Beta1";
import Beta2 from "../../../images/icons/Beta2";
const initialStateRxSummary = {
  rxPadNumbers: [],
};
interface BetaTextProps {
  text?: string;
  top?: string;
  bgColor?: string;
  marginLeft?: string;
}
const BetaText: React.FC<BetaTextProps> = ({
  text = "Beta",
  top = "-15px",
  marginLeft = "0",
  bgColor = "rgb(68 121 156)",
}) => {
  const betaTextStyle: React.CSSProperties = {
    borderRadius: "3px",
    position: "relative",
    top,
    letterSpacing: "0.5px",
    background: bgColor,
    lineHeight: 1,
    padding: "3px 5px",
    fontSize: "10px",
    fontWeight: 600,
    color: "#fff",
    textTransform: "uppercase",
    marginLeft,
  };

  return <span style={betaTextStyle}>{text}</span>;
};

export default function PrescriptionSummary(props: any) {
  const navigate = useNavigate();
  const patientId: any = sessionStorage.getItem("patientId");
  const doctorId: any = localStorage.getItem("doctorId");
  const redirectURL = localStorage.getItem("redirectURI");
  const terminateWindow = localStorage.getItem("terminateWindow");
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { onBehalfContext }: any = useOnBehalfContext();
  const [seconds, setSeconds] = useState(10);
  const [popupSeconds, setPopupSeconds] = useState(5);
  const [smallLoad, setSmallLoad] = useState(false);
  const [iDmePopup, setIDMEPopup] = useState(false);
  const [adverseEffectPopUp, setAdverseEffectPopUp] = useState(false);
  const [aiAdherence, setAiAdherence] = useState(false);
  const [adherenceData, setAdherenceData] = useState({
    adherenceFeatures: [],
    percentageOfAdherence: "",
    drugName: "",
    medicalAdherencePredictionId: "",
  });
  const [smallLoad2, setSmallLoad2] = useState(false);
  const [fromClickFA, setFromClickFA] = useState("");
  const [removeLoad, setRemoveLoad] = useState(false);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState<any>({});
  const [printLoad, setPrintLoad] = useState(false);
  const [addToMedLoad, setAddToMedLoad] = useState(false);
  const [selectedRxNumber, setSelectedRxNUmber] = useState<any>([]);
  const [savedPrescriptionData, setSaveToSavedPrescriptionData] = useState<any>(
    []
  );
  const [verifiedIdmeUuid, setVerifiedByIdmeUuid] = useState<string | null>(
    null
  );
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [locationData, setLocationData] = useState<any>(
    JSON.parse(sessionStorage.getItem("locationData")!)
  );
  const [summarySendToPharmacyData, setSendToPharmacyData] = useState<any>([]);
  const [openInfo, setOpenInfo] = useState(true);
  const [drugIdforadverse, setDrugIdForAdverse] = useState("");
  const [faPopUp, setFaPopUp] = useState(false);
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const [printPop, setPrintPop] = useState(false);
  const [foodPopUp, setFoodPopUp] = useState(false);
  const [saveToSavedPrescriptionPopUp, setSaveToSavedPrescriptionPopUp] =
    useState(false);
  const [patientEduPopUp, setPatientEduPopUp] = useState(false);
  const [popUps, setPopUps] = useState({
    emailReminderPopup: locationData?.popUpFlag?.emailReminderPopup ?? false,
    userEmailId: locationData?.popUpFlag?.userEmailId ?? false,
    ageFlag: locationData?.popUpFlag?.ageFlag ?? false,
    addressFlag: locationData?.popUpFlag?.addressFlag ?? false,
    arflag: locationData?.popUpFlag?.arflag ?? false,
  });

  let Alert2FA;
  if (fromClickFA === "STP") {
    Alert2FA = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/sendToIdMe?domain=drx.domain.ux.upgrade.${IDME_URL_END}.summary`;
  } else if (fromClickFA === "SAP") {
    Alert2FA = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/sendToIdMe?domain=drx.domain.ux.upgrade.${IDME_URL_END}.summary.print`;
  }

  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data

  const handleHideAiAdherencePopUpClick = () => {
    setAiAdherence(false);
  };
  const handleShowAiAdherencePopUpClick = () => {
    setAiAdherence(true);
  };
  const handleShowIDMEPopupClick = () => {
    setIDMEPopup(true);
  };
  const handleHideIDMEPopupClick = () => {
    setIDMEPopup(false);
    setTimeout(() => {
      dispatch(clearIdmePreferenceState());
    }, 1000);
  };
  const handleShowPrintPopupClick = () => {
    setPrintPop(true);
  };
  const handleHidePrintPopupClick = () => {
    setPrintPop(false);
  };
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    if (summarySendToPharmacyData?.url) {
      setApprovedPopup(false);
      setReportUrl({ reportUrl: summarySendToPharmacyData?.url });
      setPrintActive(true);
    } else {
      navigate("/newrxpad");
      props.getInitializeRxpad();
      setApprovedPopup(false);
      // sessionStorage.clear();
    }
  };

  const handleShowSentPopupClick = () => {
    setFaPopUp(true);
  };
  const handleHideSentPopupClick = () => {
    setFaPopUp(false);
  };

  const handleInfoClick = () => {
    setOpenInfo(!openInfo);
  };

  const handleShowAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(true);
  };
  const handleHideAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(false);
  };
  const handleShowFoodPopUpClick = () => {
    setFoodPopUp(true);
  };
  const handleHideFoodPopUpClick = () => {
    setFoodPopUp(false);
  };

  const handleShowSaveToSavedPrescriptionPopupClick = () => {
    setSaveToSavedPrescriptionPopUp(true);
  };
  const handleHideSaveToSavedPrescriptionPopupClick = () => {
    setSaveToSavedPrescriptionPopUp(false);
    navigate("/newrxpad");
    props.getInitializeRxpad();
    // sessionStorage.clear();
  };

  const handleShowPatientEduPopUpClick = () => {
    setPatientEduPopUp(true);
  };
  const handleHidePatientEduPopUpClick = () => {
    setPatientEduPopUp(false);
  };

  const handleChangeCheckBox = (selectedValue: string, e: any) => {
    if (e.target.checked) {
      setSelectedRxNUmber([...selectedRxNumber, selectedValue]);
    } else {
      setSelectedRxNUmber(
        selectedRxNumber.filter((item: any) => item !== selectedValue)
      );
    }
  };
  const saveToSavedPrescriptions = async () => {
    try {
      const bodyData = {
        prescriptionFormList: locationData?.prescriptionFormList,
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await SAVE(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSaveToSavedPrescriptionData(result?.data?.response[0]);
        handleShowSaveToSavedPrescriptionPopupClick();
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (eror) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const addToMedHistory = async () => {
    try {
      setAddToMedLoad(true);
      const bodyData = {
        prescriptionIds: selectedRxNumber,
        prescriptionFormList: locationData?.prescriptionFormList?.filter(
          (each: any) => selectedRxNumber.includes(each.rxNumber?.toString())
        ),
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await saveToMedHistory(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        await SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: `Successfully Added ${result?.data?.response[0]}`,
            variant: "success",
            open: true,
          };
        });
        await removeRX();
        setAddToMedLoad(false);
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setAddToMedLoad(false);
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong",
          variant: "error",
          open: true,
        };
      });
      setAddToMedLoad(false);
    }
  };
  const getRxPrint = async () => {
    try {
      setPrintLoad(true);
      const bodyData = {
        prescriptionFormList: locationData?.prescriptionFormList,
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await RxPrint(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setPrintLoad(false);
        setPrintActive(true);
        setReportUrl(result?.data?.response[0]);
        dispatch(loadingTopRibbon());
        handleShowPrintPopupClick();
      } else {
        setPrintActive(false);
        setPrintLoad(false);
        setReportUrl("");
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setPrintActive(false);
      setReportUrl("");
      setPrintLoad(false);
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after sometime!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const popUpApis = async ({ type, payload }: any) => {
    try {
      const params = new URLSearchParams();
      let response: any;
      switch (type) {
        case "REMINDER":
          params.append("doctorId", doctorId);
          response = await updateEmailReminder(params);
          return response;
        case "UPDATEEMAIL":
          params.append("doctorId", doctorId);
          params.append("email", payload.email);
          response = await updatePatientEmail(params);
          return response;
        case "UPDATEDEMOGRAPHICS":
          params.append("doctorId", doctorId);
          params.append("patientId", patientId);
          params.append("height", payload?.height ?? "0");
          params.append("weight", payload?.weight ?? "0");
          response = await updatePatientDemographics(params);
          return response;
        case "UPDATEADDRESS":
          params.append("doctorId", doctorId);
          params.append("patientId", patientId);
          params.append("address", payload?.address ?? "");
          params.append("city", payload?.city ?? "");
          params.append("state", payload?.state ?? "");
          params.append("zip", payload?.zip ?? "");
          response = await updatePatientAddress(params);
          return response;
      }
    } catch (err) {
      return null;
    }
  };
  async function asyncPopUps({ type, payload }: any) {
    try {
      const response = await popUpApis({ type, payload });
      if (response?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "locationData",
          JSON.stringify({
            ...locationData,
            popUpFlag: {
              ...locationData.popUpFlag,
              emailReminderPopup:
                type === "REMINDER" ? false : popUps.emailReminderPopup,
              userEmailId: type === "UPDATEEMAIL" ? false : popUps.userEmailId,
              ageFlag: type === "UPDATEDEMOGRAPHICS" ? false : popUps.ageFlag,
              addressFlag:
                type === "UPDATEADDRESS" ? false : popUps.addressFlag,
            },
          })
        );
        setPopUps({
          emailReminderPopup:
            type === "REMINDER" || type === "UPDATEEMAIL"
              ? false
              : popUps.emailReminderPopup,
          userEmailId: type === "UPDATEEMAIL" ? false : popUps.userEmailId,
          ageFlag: type === "UPDATEDEMOGRAPHICS" ? false : popUps.ageFlag,
          addressFlag: type === "UPDATEADDRESS" ? false : popUps.addressFlag,
          arflag: type === "ARFLAG" ? false : popUps.arflag,
        });
        dispatch(loadingPatientDetails());
        dispatch(loadingPrescriberDetails());
        // response?.data?.response[0].message
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: response?.data?.response[0]?.message,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  }
  const getSummarySendToPharmacy = async (
    authCheck: any,
    printFlag: any,
    from: any,
    cancel?: any
  ) => {
    setSmallLoad(from === "STP" ? true : false);
    setSmallLoad2(from === "SS" ? true : false);
    try {
      const params = new URLSearchParams();
      params.append("printflag", printFlag);
      params.append("click", authCheck);
      params.append("alert", cancel ? cancel : null);
      const bodyData = {
        prescriptionFormList: JSON.parse(
          sessionStorage.getItem("locationData")!
        )?.prescriptionFormList,
        patientId: patientId,
        authenticationEventUUID: verifiedIdmeUuid,
        authenticationUserUUID: localStorage.getItem("userIdmeUuid"),
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await summarySendToPharmacyAPI(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          SetStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
        } else {
          setSendToPharmacyData(result?.data?.response[0]);
          setSmallLoad(false);
          setSmallLoad2(false);
          handleShowApprovedPopupClick();
          dispatch(loadingTopRibbon());
          props.setSummaryTab(false);
          localStorage.removeItem("userIdmeUuid");
          localStorage.removeItem("savedPreferenceForRoute");
        }
        setSmallLoad(false);
        setSmallLoad2(false);
      } else {
        setSendToPharmacyData([]);
        setSmallLoad(false);
        setSmallLoad2(false);
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setSendToPharmacyData([]);
      setSmallLoad2(false);
      setSmallLoad(false);
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const removeRX = async (remove?: string) => {
    try {
      setRemoveLoad(remove === "remove" ? true : false);
      const localRx = locationData?.prescriptionFormList?.filter(
        (each: any) => {
          return !selectedRxNumber.includes(each?.rxNumber?.toString());
        }
      );
      var newRxList1 = localRx?.map((each: any, index: any) => {
        each.rxNumber = index + 1;
        return each;
      });
      const bodyData = {
        prescriptionFormList: newRxList1,
        patientId: patientId,
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await SubmitPresctiptions(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
        );
        sessionStorage.setItem(
          "locationData",
          JSON.stringify(result?.data?.response[0])
        );
        props.setTabList(result?.data?.response[0]?.prescriptionFormList);
        setLocationData(result?.data?.response[0]);
        setSelectedRxNUmber([]);
        setRemoveLoad(false);
      } else {
        navigate("/newrxpad");
        props.getInitializeRxpad();
        setRemoveLoad(false);
      }
    } catch (err) {
      setRemoveLoad(false);
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const submitPreferenceRoute = async () => {
    try {
      const body = {
        settingType: "MFA_ROUTE",
        enabled: true,
        savedPreference: localStorage.getItem("savedPreferenceForRoute"),
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.log("🚀 ~ submitPreference ~ error:", error);
    }
  };

  function isBrowserWindow() {
    // Check if the window is opened as a popup (not a tab)
    const isWindow = typeof window !== "undefined" && window.opener !== null;
    return isWindow;
  }

  useEffect(() => {
    if (locationData?.prescriptionErrors?.length >= 1) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: locationData?.prescriptionErrors?.map((each: any) => {
            return (
              <Box>
                <Typography
                  component={"div"}
                  fontWeight={600}
                  variant={"body2"}
                >
                  <strong> Rx-{each?.rxNumber}</strong>
                </Typography>
                {each?.errors?.map((ech: any) => {
                  return (
                    <Typography
                      component={"div"}
                      fontWeight={600}
                      variant={"body2"}
                      paddingLeft={2}
                    >
                      {" - "} {ech?.errorMessage}
                    </Typography>
                  );
                })}
              </Box>
            );
          }),
          variant: "error",
          open: true,
        };
      });
    }
    // setLocationData(JSON.parse(sessionStorage.getItem("locationData")!));
  }, [locationData]);

  useEffect(() => {
    const authCheck: any = searchParams.get("authorization");
    const printCheck: any = searchParams.get("printFlag");
    if (
      (authCheck === "true" && printCheck == null) ||
      (verifiedIdmeUuid && fromClickFA === "STP")
    ) {
      if (localStorage.getItem("savedPreferenceForRoute") === "0") {
        setTimeout(() => {
          Promise.all([
            submitPreferenceRoute(),
            getSummarySendToPharmacy(true, false, "STP"),
          ]);
        }, 1000);
      } else {
        setTimeout(() => {
          getSummarySendToPharmacy(true, false, "STP");
        }, 1000);
      }
    } else if (
      (printCheck === "true" && authCheck === "true") ||
      (verifiedIdmeUuid && fromClickFA === "SAP")
    ) {
      if (localStorage.getItem("savedPreferenceForRoute") === "0") {
        setTimeout(() => {
          Promise.all([
            submitPreferenceRoute(),
            getSummarySendToPharmacy(true, true, "SS"),
          ]);
        }, 1000);
      } else {
        setTimeout(() => {
          getSummarySendToPharmacy(true, true, "SS");
        }, 1000);
      }
    }
  }, [verifiedIdmeUuid]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (ApprovedPopup && popupSeconds > 0 && terminateWindow === "true") {
        setPopupSeconds((prev) => {
          if (prev === 0) {
            clearInterval(intervalId);
            return 0;
          } else {
            return prev - 1;
          }
        });
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [ApprovedPopup, popupSeconds]);

  useEffect(() => {
    if (popupSeconds === 0 && isBrowserWindow() && terminateWindow === "true") {
      window.close();
      sessionStorage.clear();
      localStorage.clear();
      clearClientAuthSession();
    }
  }, [popupSeconds]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (ApprovedPopup && seconds > 0 && redirectURL && !isBrowserWindow()) {
        setSeconds((prev) => {
          if (prev === 0) {
            clearInterval(intervalId);
            return 0;
          } else {
            return prev - 1;
          }
        });
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [ApprovedPopup, seconds]);

  useEffect(() => {
    if (seconds === 0 && redirectURL && !isBrowserWindow()) {
      window.location.replace(redirectURL ?? "");
      sessionStorage.clear();
      localStorage.clear();
      clearClientAuthSession();
    }
  }, [seconds]);

  return (
    <>
      {printActive ? (
        <>
          <Grid item xs={12}>
            <iframe
              src={`${REPORT_BASE_URL}${reportUrl?.reportUrl}`}
              height="500px"
              width="100%"
              title="PrintReport"
            />
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="right">
              <YSButton
                className=""
                children={"Back"}
                variant={"outlined"}
                size={"large"}
                onClick={() => {
                  // sessionStorage.clear();
                  props.getInitializeRxpad();
                  navigate("/newrxpad");
                  setPrintActive(false);
                }}
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </>
      ) : (
        <Formik
          initialValues={initialStateRxSummary}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <>
                <AlertInfo marginBottom={1} marginTop={1}>
                  <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                  <Typography color={"error"}>
                    If you want to edit PA and OnPriority then Please go back to
                    rxpad via Edit to uncheck PA and OnPriority.
                  </Typography>
                  {UserServiceState?.allowedToPrint === false && (
                    <Typography color={"error"}>
                      As per State regulatory, All prescriptions must be sent
                      electronically only.
                    </Typography>
                  )}
                  {!locationData?.popUpFlag?.pendingMandatoryPdmpReview && (
                    <>
                      <Typography color={"error"}>
                        PMP/PDMP report review required before prescribing
                        controlled substances as per state regulations.
                      </Typography>
                    </>
                  )}
                  {UserServiceState?.allowedToPrint &&
                    UserServiceState?.allowedToPrintControlledSubstances ===
                      false && (
                      <Typography color={"error"}>
                        As per State regulatory, All Controlled substance
                        prescriptions must be sent electronically only.
                      </Typography>
                    )}
                </AlertInfo>
              </>
              <SummaryInfo>
                {" "}
                <Grid
                  container
                  item
                  xs={12}
                  spacing={1}
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Grid item xs={9} md={6}>
                    <Typography
                      component="div"
                      color={"primary"}
                      variant="subtitle2"
                      fontWeight={600}
                    >
                      Allergy and Drug Interactions
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={3} md={6} textAlign={"right"}>
                    <YSButton
                      onClick={handleInfoClick}
                      className=""
                      children={"Show"}
                      size={"small"}
                      type="button"
                      variant="contained"
                      startIcon={openInfo ? <HideIcon /> : <ShowIcon />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Collapse in={openInfo}>
                      <DrugAllergyInteractions eachData={locationData} />
                    </Collapse>
                  </Grid>
                </Grid>{" "}
              </SummaryInfo>
              <Grid
                container
                item
                xs={12}
                spacing={2}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={12}>
                  <Typography
                    component="div"
                    color={"primary"}
                    variant="subtitle2"
                    fontWeight={600}
                    marginBottom={1}
                  >
                    Prescriptions Summary
                  </Typography>{" "}
                </Grid>
              </Grid>
              <SummaryBoxScroll>
                {locationData?.prescriptionFormList?.map(
                  (eachItem: any, index: any) => (
                    <SummaryBox key={index}>
                      {/* <IconButton
                      className="contained-square edit-btn"
                      color="primary"
                      onClick={() => {
                        navigate("/newrxpad");
                        props.setSelectedTab(`Rx ${eachItem?.rxNumber}`);
                        props.setTabValue(eachItem?.rxNumber);
                      }}
                    >
                      <img src={EditIcon} alt="Edit" />
                    </IconButton> */}
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={1}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                      >
                        <Grid item xs={12} md={4}>
                          <Box className="lblval chk">
                            {/* <YSCheckBox
                              className="fill checkbox"
                              name={`rxPadNumbers ${eachItem?.rxNumber}`}
                              label=""
                              onChange={(e: any) => {
                                handleChangeCheckBox(
                                  `${eachItem?.rxNumber}`,
                                  e
                                );
                              }}
                            />{" "} */}

                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              <Checkbox
                                className="fill checkbox rxs"
                                name={`rxPadNumbers ${eachItem?.rxNumber}`}
                                checked={selectedRxNumber.includes(
                                  `${eachItem?.rxNumber}`
                                )}
                                onChange={(e: any) => {
                                  handleChangeCheckBox(
                                    `${eachItem?.rxNumber}`,
                                    e
                                  );
                                }}
                              />
                              Rx No
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.rxNumber}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Rx Date
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.rxDate}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Fmlry. Status
                            </Typography>
                            <Typography component="div" variant="body2">
                              {eachItem?.formularyStatus}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Box className="lblval">
                            <Typography
                              component="div"
                              variant="body2"
                              color={"primary"}
                              fontWeight={600}
                            >
                              {eachItem?.drugDescription}
                            </Typography>
                            {eachItem?.deaClassCode && (
                              <Typography
                                component="div"
                                className="ScheduledDrugLabel"
                                variant="body2"
                              >
                                {eachItem?.deaClassCode}
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Co-Pay
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.copay}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              SIG
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.sig}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Qualifier
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.qtyQualifier}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Quantity
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.quantity}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              No. Of Refills
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.refills}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Substitutions
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.substitution}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Note to Pharmacist
                            </Typography>{" "}
                            <Typography component="div" variant="body2">
                              {eachItem?.instructions}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box className="lblval">
                            <Typography
                              component="label"
                              variant="body2"
                              fontWeight={600}
                            >
                              Pharmacy
                            </Typography>{" "}
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={
                                eachItem?.pharmacyDetails ? (
                                  <PharmacyDetails
                                    row={eachItem?.pharmacyDetails}
                                  />
                                ) : (
                                  "Not Selected"
                                )
                              }
                              className="w316"
                            >
                              {eachItem?.pharmacyDetails?.pharmacyName ? (
                                <Typography
                                  component="div"
                                  variant="body2"
                                  color={"primary"}
                                  sx={{ cursor: "pointer" }}
                                >
                                  {eachItem?.pharmacyDetails?.pharmacyName}
                                </Typography>
                              ) : (
                                <Typography
                                  component="div"
                                  variant="body2"
                                  color={"error"}
                                >
                                  Not Selected
                                </Typography>
                              )}
                            </HtmlTooltip>
                          </Box>
                        </Grid>
                        {eachItem?.pharmacyDetails?.ssEnabled === false ? (
                          <Grid item xs={12} md={4}>
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={
                                "Electronic transmission of prescriptions is disabled for this pharmacy."
                              }
                              className="w316 red"
                            >
                              <CancelRoundedIcon
                                sx={{ cursor: "pointer" }}
                                color="error"
                              />
                            </HtmlTooltip>
                          </Grid>
                        ) : eachItem?.pharmacyDetails?.epcsEnabled === false &&
                          eachItem?.controlledSubstance === true ? (
                          <Grid item xs={12} md={4}>
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={
                                "Electronic transmission of prescriptions containing Controlled drugs is not supported by this pharmacy."
                              }
                              className="w316 orange"
                            >
                              <WarningRoundedIcon
                                sx={{ cursor: "pointer" }}
                                color="warning"
                              />
                            </HtmlTooltip>
                          </Grid>
                        ) : (
                          <Grid item xs={12} md={4}>
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={
                                "This pharmacy supports electronic prescription transmission."
                              }
                              className="w316 green"
                            >
                              <CheckCircleRoundedIcon
                                sx={{ cursor: "pointer" }}
                                color="success"
                              />
                            </HtmlTooltip>
                          </Grid>
                        )}
                        <Grid item xs={12}>
                          <Box className={"checkboxgrp"}>
                            {eachItem?.priorAuthorization && (
                              <Typography variant="body2" component={"span"}>
                                <Checkbox
                                  name={"PA"}
                                  defaultChecked={eachItem?.priorAuthorization}
                                  disabled={true}
                                  onChange={(opt, e) => console.log(opt)}
                                />
                                PA
                              </Typography>
                            )}
                            {eachItem?.priorityIndicator && (
                              <Typography variant="body2" component={"span"}>
                                <Checkbox
                                  name={"OnPriority"}
                                  defaultChecked={eachItem?.priorityIndicator}
                                  disabled={true}
                                  onChange={(opt, e) => console.log(opt)}
                                />
                                On Priority
                              </Typography>
                            )}

                            {eachItem?.postDatedPrescription && (
                              <Typography variant="body2" component={"span"}>
                                <Checkbox
                                  name={"PostDatedPresciption"}
                                  defaultChecked={
                                    eachItem?.postDatedPrescription
                                  }
                                  disabled={true}
                                  onChange={(opt, e) => console.log(opt)}
                                />
                                Post Dated Presciption
                                <b> {eachItem?.postDatedPrescriptionDate}</b>
                              </Typography>
                            )}
                            {eachItem?.epcsQueued && (
                              <Typography variant="body2" component={"span"}>
                                <Checkbox
                                  name={"EPCSQueued"}
                                  defaultChecked={eachItem?.epcsQueued}
                                  disabled={true}
                                  onChange={(opt, e) => console.log(opt)}
                                />
                                EPCS Queued
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                        <Grid
                          display={"flex"}
                          justifyContent="space-between"
                          item
                          xs={12}
                        >
                          <Box className="btns">
                            <YSButton
                              className={""}
                              children={"Adverse Effects"}
                              onClick={() => {
                                setDrugIdForAdverse(eachItem?.drugId);
                                handleShowAdverseEffectPopUpClick();
                              }}
                              variant={"contained"}
                              size={"medium"}
                            />{" "}
                            <YSButton
                              className={""}
                              children={"Drug to Food Interactions"}
                              onClick={() => {
                                setDrugIdForAdverse(eachItem?.drugId);
                                handleShowFoodPopUpClick();
                              }}
                              variant={"contained"}
                              size={"medium"}
                            />
                            <YSButton
                              className={""}
                              children={"Patient Education"}
                              onClick={() => {
                                handleShowPatientEduPopUpClick();
                              }}
                              variant={"contained"}
                              size={"medium"}
                            />
                          </Box>
                          {eachItem?.percentageOfAdherence && (
                            <Box>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                gap={1}
                                position={"relative"}
                              >
                                <AIIcon />

                                <BetaText top="-15px" marginLeft="-20px" />
                                <Typography component="div" variant="body2">
                                  Our AI indicates the patient's medication
                                  <br />
                                  adherence is{" "}
                                  <b>
                                    {eachItem?.percentageOfAdherence}%
                                  </b>.{" "}
                                  <Typography
                                    variant="body2"
                                    component="span"
                                    color="primary"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setAdherenceData({
                                        ...adherenceData,
                                        percentageOfAdherence:
                                          eachItem?.percentageOfAdherence,
                                        adherenceFeatures:
                                          eachItem?.adherenceFeatures,
                                        drugName: eachItem?.drugDescription,
                                        medicalAdherencePredictionId:
                                          eachItem?.medicalAdherencePredictionId,
                                      });
                                      handleShowAiAdherencePopUpClick();
                                    }}
                                    fontWeight={600}
                                  >
                                    Find more details
                                  </Typography>
                                </Typography>
                              </Box>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    </SummaryBox>
                  )
                )}
              </SummaryBoxScroll>{" "}
              <AlertInfo marginBottom={1} marginTop={1}>
                <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                <Typography color={"error"}>
                  Options below with * requires the Rx No boxes to be checked
                  for processing. For other options, checking the box will not
                  have any effect.
                </Typography>
              </AlertInfo>
              <SummaryBtns>
                <YSButton
                  children={
                    removeLoad ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "* Remove"
                    )
                  }
                  onClick={() => {
                    if (selectedRxNumber.length >= 1) {
                      removeRX("remove");
                    } else {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message: "Please Select at least one prescription!",
                          variant: "error",
                          open: true,
                        };
                      });
                    }
                  }}
                  variant={"outlined"}
                  size={"large"}
                  startIcon={
                    <img src={TrashIcon} alt="Delete" loading="lazy" />
                  }
                />
                <YSButton
                  size="large"
                  variant="outlined"
                  disabled={false}
                  type="button"
                  children={"Save"}
                  onClick={() => {
                    saveToSavedPrescriptions();
                  }}
                  startIcon={<img src={SaveIcon} alt="save" loading="lazy" />}
                />
                <YSButton
                  children={
                    printLoad ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "Print"
                    )
                  }
                  onClick={() => {
                    if (locationData?.popUpFlag?.pharmacyNotSelected) {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "One or more prescriptions is missing a pharmacy.",
                          variant: "error",
                          open: true,
                        };
                      });
                    } else {
                      getRxPrint();
                    }
                  }}
                  startIcon={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id &&
                    UserServiceState?.profileGroup !== 11 ? (
                      <img src={PrintIcon} alt="print" loading="lazy" />
                    ) : UserServiceState?.profileGroup > 6 ? (
                      <LockIcon />
                    ) : (
                      <img src={PrintIcon} alt="print" loading="lazy" />
                    )
                  }
                  disabled={
                    // (onBehalfContext?.id && UserServiceState?.profileGroup != 11
                    //   ? false
                    //   : UserServiceState?.profileGroup > 6
                    //   ? true
                    //   : UserServiceState?.allowedToPrint
                    //   ? UserServiceState?.allowedToPrintControlledSubstances ===
                    //       false &&
                    //     locationData?.popUpFlag?.printButtonDisabled === true
                    //     ? true
                    //     : false
                    //   : true) ?? false
                    onBehalfContext?.id &&
                    UserServiceState?.profileGroup !== 11 &&
                    !locationData?.popUpFlag?.printButtonDisabled
                      ? false
                      : UserServiceState?.profileGroup > 6 ||
                        locationData?.popUpFlag?.printButtonDisabled
                      ? true
                      : false
                  }
                  variant={"outlined"}
                  size={"large"}
                />
                <YSButton
                  onClick={() => {
                    if (locationData?.popUpFlag?.pharmacyNotSelected) {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "One or more prescriptions is missing a pharmacy.",
                          variant: "error",
                          open: true,
                        };
                      });
                    } else if (locationData?.popUpFlag?.scheduleDrug) {
                      setFromClickFA("SAP");
                      handleShowSentPopupClick();
                    } else {
                      getSummarySendToPharmacy(false, true, "SS");
                    }
                  }}
                  className=""
                  disabled={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                      ? false
                      : UserServiceState?.profileGroup > 6
                      ? true
                      : false
                  }
                  startIcon={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                      ? null
                      : UserServiceState?.profileGroup > 6 && <LockIcon />
                  }
                  children={
                    smallLoad2 ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "Send & Print"
                    )
                  }
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="outlined"
                />
                <YSButton
                  onClick={() => {
                    addToMedHistory();
                  }}
                  className=""
                  children={
                    addToMedLoad ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "* Add to Medication History"
                    )
                  }
                  size={"large"}
                  type="submit"
                  color="primary"
                  variant="outlined"
                  startIcon={<AddCircleOutlineOutlinedIcon />}
                />
                <YSButton
                  onClick={() => {
                    if (locationData?.popUpFlag?.pharmacyNotSelected) {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "One or more prescriptions is missing a pharmacy.",
                          variant: "error",
                          open: true,
                        };
                      });
                    } else if (locationData?.popUpFlag?.scheduleDrug) {
                      handleShowSentPopupClick();
                      setFromClickFA("STP");
                    } else {
                      getSummarySendToPharmacy(false, false, "STP");
                    }
                  }}
                  className=""
                  disabled={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id && UserServiceState?.profileGroup !== 11
                      ? false
                      : UserServiceState?.profileGroup > 6
                      ? true
                      : false
                  }
                  startIcon={
                    // localStorage.getItem("onBehalf")
                    onBehalfContext?.id &&
                    UserServiceState?.profileGroup !== 11 ? (
                      <img
                        src={SendPharmacyIcon}
                        alt="Send to Pharmacy"
                        loading="lazy"
                      />
                    ) : UserServiceState?.profileGroup > 6 ? (
                      <LockIcon />
                    ) : (
                      <img
                        src={SendPharmacyIcon}
                        alt="Send to Pharmacy"
                        loading="lazy"
                      />
                    )
                  }
                  children={
                    // smallLoad ? (
                    //   <CircularProgress color="inherit" size={28} />
                    // ) : (
                    //   "Send to Pharmacy"
                    // )
                    "Send to Pharmacy"
                  }
                  size={"large"}
                  type="button"
                  color="primary"
                  variant="contained"
                />
              </SummaryBtns>
            </Form>
          )}
        </Formik>
      )}
      {/* {Back Drop Loader} */}
      <Backdrop
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={smallLoad}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      {/* AI Adherence popup */}
      <DialogPopup
        title="AI Prediction"
        beta={<BetaText top="0px" bgColor="rgb(19 54 78)" />}
        windowsize={"sm"}
        show={aiAdherence}
        handleShowPopupClick={handleShowAiAdherencePopUpClick}
        handleHidePopupClick={handleHideAiAdherencePopUpClick}
      >
        <AIMedInfo adherenceData={adherenceData} />
      </DialogPopup>
      {/* Approved STP POPup */}
      <DialogPopup
        title="Prescription Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          padding={2}
          justifyContent="center"
        >
          {summarySendToPharmacyData?.statusCode === 0 ? (
            <Grid item xs={12} textAlign={"center"}>
              <CheckCircleOutlineIcon
                style={{ height: 70, width: 70 }}
                color="success"
              />
            </Grid>
          ) : summarySendToPharmacyData?.statusCode === 2 ? (
            <Grid item xs={12} textAlign={"center"}>
              <CancelOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="error"
              />
            </Grid>
          ) : summarySendToPharmacyData?.statusCode === 1 ? (
            <Grid item xs={12} textAlign={"center"}>
              <ErrorOutlineOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="warning"
              />
            </Grid>
          ) : null}
          <>
            {summarySendToPharmacyData?.epaReturnList?.successMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescriptions added to Holding Queue:
                </Typography>
                {summarySendToPharmacyData?.epaReturnList?.successMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.epaReturnList?.failureMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescriptions failed to add to Holding queue:
                </Typography>
                {summarySendToPharmacyData?.epaReturnList?.failureMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsReturnList?.successMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescriptions added to EPCS Queue:
                </Typography>
                {summarySendToPharmacyData?.epcsReturnList?.successMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsReturnList?.failureMedicationList
              ?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Failed to add prescriptions to EPCS Queue:
                </Typography>
                {summarySendToPharmacyData?.epcsReturnList?.failureMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsWithEpaReturnList
              ?.successMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescriptions added to EPCS queue and added to EPA Holding
                  Queue successfully:
                </Typography>
                {summarySendToPharmacyData?.epcsWithEpaReturnList?.successMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.epcsWithEpaReturnList
              ?.failureMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescriptions added to EPCS Queue and failed to add into EPA
                  Holding Queue:
                </Typography>
                {summarySendToPharmacyData?.epcsWithEpaReturnList?.failureMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.postDatedReturnList
              ?.successMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescription added as Post dated prescription:
                </Typography>
                {summarySendToPharmacyData?.postDatedReturnList?.successMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.postDatedReturnList
              ?.failureMedicationList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Prescription failed to add as Post dated prescription:
                </Typography>
                {summarySendToPharmacyData.postDatedReturnList?.failureMedicationList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.electronicReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs sent electronically:
                </Typography>
                {summarySendToPharmacyData?.electronicReturnList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.printReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs to be printed:
                </Typography>
                {summarySendToPharmacyData?.printReturnList?.map(
                  (each: any) => (
                    <ul>
                      <li>{each}</li>
                    </ul>
                  )
                )}
              </Grid>
            )}
            {summarySendToPharmacyData?.rejectedList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  {UserServiceState?.allowedToPrint ? (
                    <Typography
                      component="div"
                      variant="subtitle2"
                      color={"error"}
                      fontWeight={500}
                    >
                      As per State regulatory, All Controlled substance
                      prescriptions must be sent electronically only.
                    </Typography>
                  ) : (
                    <Typography
                      component="div"
                      variant="subtitle2"
                      color={"error"}
                      fontWeight={500}
                    >
                      As per State regulatory, All prescriptions must be sent
                      electronically only.
                    </Typography>
                  )}
                  Drugs rejected:
                </Typography>
                {summarySendToPharmacyData?.rejectedList?.map((each: any) => (
                  <ul>
                    <li>{each}</li>
                  </ul>
                ))}
                <Typography
                  component="div"
                  variant="subtitle2"
                  color={"error"}
                  fontWeight={600}
                >
                  Please RE-PRESCRIBE the rejected drugs.
                </Typography>
              </Grid>
            )}
          </>
        </Grid>
        {isBrowserWindow() && terminateWindow === "true" && (
          <Grid
            item
            xs={12}
            bgcolor={"#FFC0CB"}
            bottom={0}
            position={"sticky"}
            padding={2}
          >
            <Typography textAlign="left" variant="subtitle2" fontWeight={400}>
              Application will be closed in <b>{popupSeconds}</b> seconds.
            </Typography>
          </Grid>
        )}
        {redirectURL && !isBrowserWindow() && (
          <Grid
            item
            xs={12}
            bgcolor={"#FFC0CB"}
            bottom={0}
            position={"sticky"}
            padding={2}
          >
            <Typography textAlign="left" variant="subtitle2" fontWeight={400}>
              You will be redirected to your EMR application in <b>{seconds}</b>{" "}
              seconds.
              <br />
              If your browser doesn't redirect you automatically, please{" "}
              <Link
                variant="subtitle2"
                fontWeight={500}
                href={redirectURL || ""}
                display={"inline"}
                onClick={() => {
                  sessionStorage.clear();
                  localStorage.clear();
                  clearClientAuthSession();
                }}
              >
                Click here.
              </Link>
            </Typography>
          </Grid>
        )}
      </DialogPopup>
      {/* Print PopUP */}
      <DialogPopup
        title="Print Status"
        windowsize={"sm"}
        show={printPop}
        handleShowPopupClick={handleShowPrintPopupClick}
        handleHidePopupClick={handleHidePrintPopupClick}
      >
        <>
          <Grid item xs={12} textAlign={"center"}>
            <CheckCircleOutlineIcon
              style={{ height: 70, width: 70 }}
              color="success"
            />
          </Grid>
          {reportUrl?.printReturnList && (
            <>
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Drugs to be printed:
                </Typography>
                <ul>
                  {reportUrl?.printReturnList?.map((each: any) => (
                    <>
                      <li>{each}</li>
                    </>
                  ))}
                </ul>
              </Grid>
            </>
          )}
        </>
      </DialogPopup>
      {/* Remind me later */}
      <DialogPopup
        windowsize={"sm"}
        show={popUps.emailReminderPopup}
        handleShowPopupClick={() => {
          setPopUps({ ...popUps, emailReminderPopup: true });
        }}
        handleHidePopupClick={
          null
          //   () => {
          //   setPopUps({ ...popUps, emailReminderPopup: false });
          // }
        }
      >
        <Formik
          validationSchema={yup.object().shape({
            email: yup.string().email("Invalid email."),
          })}
          initialValues={{ email: "" }}
          onSubmit={(values: any) => {
            asyncPopUps({
              type: "UPDATEEMAIL",
              payload: { email: values.email },
            });
          }}
        >
          {(emailProps: any) => (
            <Box
              style={{
                minHeight: 200,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                item
                xs={12}
                spacing={1}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item xs={12} textAlign={"center"}>
                  <Typography
                    component="span"
                    variant="subtitle1"
                    fontWeight={400}
                  >
                    Update your email ID to receive all sorts of communication
                    notifications.
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="lastname"
                    >
                      Email
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <TextField
                          id="email"
                          name="email"
                          type="text"
                          className="input"
                          disabled={false}
                          value={emailProps.values?.email}
                          onChange={emailProps.handleChange}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={6} textAlign={"center"}>
                  <YSButton
                    className={"green"}
                    children={"Remind me later"}
                    onClick={() => {
                      asyncPopUps({ type: "REMINDER" });
                    }}
                    variant={"contained"}
                    size={"large"}
                  />
                  <YSButton
                    className={""}
                    children={"Save"}
                    onClick={() => {
                      emailProps.handleSubmit();
                    }}
                    variant={"contained"}
                    size={"large"}
                    style={{ marginLeft: 5 }}
                  />
                </Grid>
              </Grid>{" "}
            </Box>
          )}
        </Formik>
      </DialogPopup>
      {/* Update Email */}
      <DialogPopup
        title={"Update Contact Info"}
        windowsize={"sm"}
        show={popUps.userEmailId}
        handleShowPopupClick={() => {
          setPopUps({ ...popUps, userEmailId: true });
        }}
        handleHidePopupClick={() => {
          setPopUps({ ...popUps, userEmailId: false });
        }}
      >
        <Formik
          validationSchema={yup.object().shape({
            email: yup.string().email("Invalid email."),
          })}
          initialValues={{ email: "" }}
          onSubmit={(values: any) => {
            asyncPopUps({
              type: "UPDATEEMAIL",
              payload: { email: values.email },
            });
          }}
        >
          {(emailProps: any) => (
            <Grid
              container
              item
              xs={12}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography component="span" variant="body2" fontWeight={400}>
                  EPCS Queue & Post Dated prescriptions related notifications
                  will be sent to your mail address. Please let us know your
                  mail to keep you updated.
                </Typography>{" "}
              </Grid>
              <Grid item xs={12}>
                <InputSMBoxStyle>
                  <Typography
                    component="label"
                    variant="body2"
                    htmlFor="lastname"
                  >
                    Email
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <TextField
                        id="email"
                        name="email"
                        type="text"
                        className="input"
                        disabled={false}
                        value={emailProps.values?.email}
                        onChange={emailProps.handleChange}
                      />
                    </DRxInputStyle>
                    <YSButton
                      className={""}
                      children={"Save"}
                      onClick={() => {
                        emailProps.handleSubmit();
                      }}
                      variant={"contained"}
                      size={"large"}
                      style={{ marginTop: 10 }}
                    />
                  </Box>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12} textAlign={"center"}></Grid>{" "}
              <Grid item xs={12}>
                <AlertInfo>
                  <Typography component={"div"} variant={"body2"}>
                    <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                    <Typography
                      color={"green"}
                      component={"span"}
                      variant={"body2"}
                    >
                      Please use a valid email address for EPCS Queue or Post
                      Dated Prescription Alerts to avoid any miss outs on
                      Prescription processing.
                    </Typography>
                  </Typography>{" "}
                </AlertInfo>
              </Grid>
            </Grid>
          )}
        </Formik>
      </DialogPopup>
      {/* Update patient Demo */}
      <DialogPopup
        title={
          " Enter Height and Weight for pediatrician patients whose age is  below 18 years"
        }
        windowsize={"sm"}
        show={popUps.ageFlag}
        handleShowPopupClick={() => {
          setPopUps({ ...popUps, ageFlag: true });
        }}
        handleHidePopupClick={() => {
          setPopUps({ ...popUps, ageFlag: false });
        }}
      >
        <Formik
          // validationSchema={yup.object().shape({
          //   height: yup.number(),
          //   weight: yup.number(),
          // })}
          initialValues={{ height: 0, weight: 0 }}
          onSubmit={(values: any) => {
            asyncPopUps({
              type: "UPDATEDEMOGRAPHICS",
              payload: { height: values.height, weight: values.weight },
            });
          }}
        >
          {(demoProps: any) => (
            <Grid
              container
              item
              xs={12}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="label"
                  variant="subtitle2"
                  color={"primary"}
                  fontWeight={600}
                >
                  Patient Personal Information:
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="label"
                  variant="body2"
                  color={"primary"}
                  fontWeight={400}
                >
                  Height(Inches)
                </Typography>
              </Grid>{" "}
              <Grid item xs={9}>
                <Typography component="div" variant="body2" fontWeight={400}>
                  Enter height only in inches, no text & special characters
                  allowed (ex: Enter 38 Inches if patient height is 3 feet 2
                  inches)
                </Typography>
              </Grid>{" "}
              <Grid item xs={3}>
                <TextField
                  id="height"
                  name="height"
                  type="number"
                  className="input"
                  disabled={false}
                  fullWidth
                  onChange={demoProps.handleChange}
                  value={demoProps.values.height}
                />
              </Grid>
              {/* Weight */}
              <Grid item xs={12} textAlign={"left"}>
                <Typography
                  component="label"
                  variant="body2"
                  color={"primary"}
                  fontWeight={400}
                >
                  Weight (Ibs(rounded))
                </Typography>
              </Grid>{" "}
              <Grid item xs={9} textAlign={"left"}>
                <Typography component="label" variant="body2" fontWeight={400}>
                  Enter Weight only in ibs(rounded), no text & special
                  characters allowed
                </Typography>
              </Grid>{" "}
              <Grid item xs={3}>
                <TextField
                  id="weight"
                  name="weight"
                  type="number"
                  className="input"
                  disabled={false}
                  onChange={demoProps.handleChange}
                  value={demoProps.values.weight}
                />
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <YSButton
                  className={""}
                  children={"Save"}
                  onClick={() => {
                    demoProps.handleSubmit();
                  }}
                  variant={"contained"}
                  size={"large"}
                />
              </Grid>
            </Grid>
          )}
        </Formik>
      </DialogPopup>
      {/* update Patient address */}
      <DialogPopup
        windowsize={"sm"}
        title={"Patient needs to have Address"}
        show={popUps.addressFlag}
        handleShowPopupClick={() => {
          setPopUps({ ...popUps, addressFlag: true });
        }}
        handleHidePopupClick={() => {
          setPopUps({ ...popUps, addressFlag: false });
        }}
      >
        <Formik
          initialValues={{
            address: "",
            city: "",
            state: "",
            zip: 0,
          }}
          onSubmit={(values: any) => {
            asyncPopUps({
              type: "UPDATEADDRESS",
              payload: {
                address: values.address,
                city: values.city,
                state: values.state,
                zip: values.zip,
              },
            });
          }}
        >
          {(addressProps: any) => (
            <Grid
              container
              xs={12}
              md={10}
              spacing={1}
              alignItems="top"
              justifyContent="center"
            >
              <Grid item xs={12}>
                <Typography
                  component="label"
                  variant="body2"
                  color={"primary"}
                  fontWeight={400}
                >
                  Patient Personal Information:
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} md={5}>
                <Typography
                  component="label"
                  variant="body2"
                  fontWeight={400}
                  style={{
                    marginTop: 7,
                  }}
                >
                  Address
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} md={7}>
                <TextField
                  id="address"
                  name="address"
                  type="text"
                  className="input"
                  disabled={false}
                  onChange={addressProps.handleChange}
                  value={addressProps.values.address}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <Typography
                  component="label"
                  variant="body2"
                  fontWeight={400}
                  style={{
                    marginTop: 7,
                  }}
                >
                  City
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} md={7}>
                <TextField
                  id="city"
                  name="city"
                  type="text"
                  className="input"
                  disabled={false}
                  onChange={addressProps.handleChange}
                  value={addressProps.values.city}
                />
              </Grid>
              {/*  */}
              <Grid item xs={12} md={5}>
                <Typography
                  component="label"
                  variant="body2"
                  fontWeight={400}
                  style={{
                    marginTop: 7,
                  }}
                >
                  State
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} md={7}>
                <DRxSelectStyle>
                  <YSSelectSearch
                    id="state"
                    options={
                      AllDropdwonsState?.statesOptions ?? [
                        { label: "", value: "" },
                      ]
                    }
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?.label === value
                    }
                    name="StateName"
                    value={addressProps.values.StateName}
                    onChange={(event: any, value: any) => {
                      addressProps.setFieldValue("state", value.value);
                    }}
                    onInputChange={(option: any, e: any) => {
                      addressProps.setFieldValue("stateName", e);
                    }}
                    error={
                      addressProps.touched.State &&
                      Boolean(addressProps.errors.State)
                    }
                  />
                </DRxSelectStyle>
              </Grid>
              <Grid item xs={12} md={5}>
                <Typography
                  component="label"
                  variant="body2"
                  fontWeight={400}
                  style={{
                    marginTop: 7,
                  }}
                >
                  Zip
                </Typography>
              </Grid>{" "}
              <Grid item xs={12} md={7}>
                <TextField
                  id="zip"
                  name="zip"
                  type="number"
                  className="input"
                  disabled={false}
                  onChange={addressProps.handleChange}
                  value={addressProps.values.zip}
                />
              </Grid>
              <Grid item xs={12} md={5}></Grid>
              <Grid item xs={12} md={7} textAlign={"left"}>
                <YSButton
                  className={""}
                  children={"Save"}
                  onClick={() => {
                    addressProps.handleSubmit();
                  }}
                  variant={"contained"}
                  size={"large"}
                />
              </Grid>
            </Grid>
          )}
        </Formik>
      </DialogPopup>
      {/* adverse effect */}
      <DialogPopup
        title="Adverse Effects"
        windowsize={"sm"}
        show={adverseEffectPopUp}
        handleShowPopupClick={handleShowAdverseEffectPopUpClick}
        handleHidePopupClick={handleHideAdverseEffectPopUpClick}
      >
        <AdverseEffectPOPUp drugIdforadverse={drugIdforadverse} />
      </DialogPopup>
      {/* food interactions */}
      <DialogPopup
        title="Drug to Food Interactions"
        windowsize={"sm"}
        show={foodPopUp}
        handleShowPopupClick={handleShowFoodPopUpClick}
        handleHidePopupClick={handleHideFoodPopUpClick}
      >
        <DrugToFoodInteractionPopUp drugIdforadverse={drugIdforadverse} />
      </DialogPopup>
      {/* Patient Education */}
      <DialogPopup
        title="Patient Education"
        windowsize={"sm"}
        show={patientEduPopUp}
        handleShowPopupClick={handleShowPatientEduPopUpClick}
        handleHidePopupClick={handleHidePatientEduPopUpClick}
      >
        <Typography>Info not available</Typography>
      </DialogPopup>
      {/* epcs alert 2FA */}
      <DialogPopup
        title="EPCS Alert"
        windowsize={"sm"}
        show={faPopUp}
        handleShowPopupClick={handleShowSentPopupClick}
        handleHidePopupClick={handleHideSentPopupClick}
      >
        <EPCSAlert
          handleHideSentPopupClick={handleHideSentPopupClick}
          URL={Alert2FA}
          handleShowIDMEPopupClick={handleShowIDMEPopupClick}
          getSummarySendToPharmacy={getSummarySendToPharmacy}
          message={true}
          multiDea={false}
          fromClickFA={fromClickFA}
        />
      </DialogPopup>
      {/* IDME verification popup */}
      <DialogPopup
        title="Two-Factor Authentication"
        windowsize={"md"}
        show={iDmePopup}
        handleShowPopupClick={handleShowIDMEPopupClick}
        handleHidePopupClick={handleHideIDMEPopupClick}
      >
        <IDME
          URL={Alert2FA}
          setVerifiedByIdmeUuid={setVerifiedByIdmeUuid}
          handleHidePopupClick={handleHideIDMEPopupClick}
        />
      </DialogPopup>
      {/* AR Flag popup */}
      <DialogPopup
        windowsize={"sm"}
        show={popUps.arflag}
        handleShowPopupClick={() => {
          setPopUps({ ...popUps, arflag: true });
        }}
        handleHidePopupClick={() => {
          setPopUps({ ...popUps, arflag: false });
        }}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <Typography component="div" variant="h4" fontWeight={400}>
              You are not allowed to send this prescription electronically as
              per state regulatory. Please let us know if you want to proceed
              with printing the prescription.
            </Typography>{" "}
          </Grid>
          <Grid item xs={6} textAlign={"center"}>
            <YSButton
              className={""}
              children={"CANCEL"}
              onClick={() => {
                setPopUps({ ...popUps, arflag: false });
              }}
              variant={"outlined"}
              size={"large"}
              style={{ marginTop: 10 }}
            />
          </Grid>
          <Grid item xs={6} textAlign={"center"}>
            <YSButton
              className={""}
              children={"OK"}
              onClick={() => {
                getSummarySendToPharmacy(false, false, "STP");
              }}
              variant={"contained"}
              size={"large"}
              style={{ marginTop: 10 }}
            />
          </Grid>{" "}
        </Grid>
      </DialogPopup>
      {/* Save to saved prescription */}
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={saveToSavedPrescriptionPopUp}
        handleShowPopupClick={handleShowSaveToSavedPrescriptionPopupClick}
        handleHidePopupClick={handleHideSaveToSavedPrescriptionPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          {savedPrescriptionData?.saveSuccessReturnList?.length >= 1 ? (
            <Grid item xs={12} textAlign={"center"}>
              <CheckCircleOutlineIcon
                style={{ height: 70, width: 70 }}
                color="success"
              />
            </Grid>
          ) : (
            <Grid item xs={12} textAlign={"center"}>
              <CancelOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="error"
              />
            </Grid>
          )}
          <>
            {savedPrescriptionData?.saveSuccessReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s) saved successfully:{" "}
                  {savedPrescriptionData?.saveSuccessReturnList?.map(
                    (each: any) => (
                      <ul>
                        <li>{each}</li>
                      </ul>
                    )
                  )}
                </Typography>
              </Grid>
            )}
            {savedPrescriptionData?.saveFaliureReturnList?.length >= 1 && (
              <Grid item xs={12} textAlign={"left"}>
                <Typography component="span" variant="subtitle2">
                  Drug(s) failed to save:{" "}
                  {savedPrescriptionData?.saveFaliureReturnList?.map(
                    (each: any) => (
                      <ul>
                        <li>{each}</li>
                      </ul>
                    )
                  )}
                </Typography>
              </Grid>
            )}
          </>
        </Grid>
      </DialogPopup>

      {/* 
      <DialogPopup
        title="One more step to get your account created"
        windowsize={"sm"}
        show={adverseEffectPopUp}
        handleShowPopupClick={handleShowAdverseEffectPopUpClick}
        handleHidePopupClick={handleHideAdverseEffectPopUpClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item xs={12} md={12}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                ID proofing needed to authorize e-Prescribing
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogPopup> */}
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}

export const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyName ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.twentyFourHourFlag ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.storeNo ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyAddress ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.landMark ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.city ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.state ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.zip ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyPhone ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.faxNo ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
